export const mobileMaxWidth = 480;
export const tabletMinWidth = 481;
export const tabletMaxWidth = 952;
export const desktopMinWidth = 953;
export const desktopMaxWidth = 1247;
export const lrgDesktopMinWidth = 1248;

export const variables = {
  global: {
    lrgDesktopMinWidth: `${lrgDesktopMinWidth}px`,
    desktopMaxWidth: `${desktopMaxWidth}px`,
    desktopMinWidth: `${desktopMinWidth}px`,
    tabletMaxWidth: `${tabletMaxWidth}px`,
    tabletMinWidth: `${tabletMinWidth}px`,
    mobileMaxWidth: `${mobileMaxWidth}px`,
    mobileMinWidth: '0px',
    pageBodyWidth: `${lrgDesktopMinWidth}px`,
  },
};

export type MediaQuery =
  | '>mobile'
  | '>=mobile'
  | '>tablet'
  | '>=tablet'
  | '>desktop'
  | '>=desktop'
  | '>lrg-desktop'
  | '>=lrg-desktop'
  | '<mobile'
  | '<=mobile'
  | '<tablet'
  | '<=tablet'
  | '<desktop'
  | '<=desktop'
  | '<lrg-desktop'
  | '<=lrg-desktop';

function processQuery(query: MediaQuery): string {
  switch (query) {
    case '>mobile':
      return '(min-width: 321px)';
    case '>=mobile':
      return '(min-width: 320px)';
    case '>tablet':
      return `(min-width: ${tabletMinWidth + 1}px)`;
    case '>=tablet':
      return `(min-width: ${tabletMinWidth}px)`;
    case '>desktop':
      return `(min-width: ${desktopMinWidth + 1}px)`;
    case '>=desktop':
      return `(min-width: ${desktopMinWidth}px)`;
    case '>lrg-desktop':
      return `(min-width: ${desktopMaxWidth + 1}px)`;
    case '>=lrg-desktop':
      return `(min-width: ${desktopMaxWidth}px)`;

    case '<mobile':
      return '(max-width: 319px)';
    case '<=mobile':
      return '(max-width: 320px)';
    case '<tablet':
      return `(max-width: ${tabletMinWidth - 1}px)`;
    case '<=tablet':
      return `(max-width: ${tabletMinWidth}px)`;
    case '<desktop':
      return `(max-width: ${desktopMinWidth - 1}px)`;
    case '<=desktop':
      return `(max-width: ${desktopMinWidth}px)`;
    case '<lrg-desktop':
      return `(max-width: ${desktopMaxWidth - 1}px)`;
    case '<=lrg-desktop':
      return `(max-width: ${desktopMaxWidth}px)`;

    default:
      throw new Error(
        `Unrecognised arg in \`media('${query}')\`, please read src/styles/breakpoints-2026.ts to see supported args.`,
      );
  }
}

export function media(...queries: MediaQuery[]): string {
  if (queries.length < 1) {
    throw new Error('Must supply at least one argument to `media`.');
  }

  return `@media ${queries.map(processQuery).join(' and ')}`;
}

export default media;
